export default __webpack_public_path__ + "static/media/namelogo.2588b11d.svg";